import Repository from "@/repositories/api.js"
const resource = "/admin/map_icons"

export default {
  async getAll() {
    let response = await Repository.get(resource, {
      params: {}
    })
    return response.data.map_icons
  }
}
